<template>
    <div id="countdown" class="bg-white">
        <div class="container">
            <div class="row">
                <div class="col-md-10 col-md-offset-1">
                    <div class="countdown bg-white border border-gray-light border-round sm-no-padding-rl no-padding-rl sm-padding-5 padding-2-5 position-relative">
                        <div class="no-padding-tb padding-3-5">
                            <div class="row">
                                <div class="col-md-6 countdown-text" data-mh="mh-col-countdown">
                                    <div class="display-table height-100 width-100">
                                        <div class="display-table-cell vertical-align-middle sm-text-center">
                                            <span class="display-block font-family-alt font-weight-700 letter-spacing-1 xs-text-extra-large title-medium text-uppercase">Sæt kryds i kalenderen</span>
                                            <span class="display-block font-family-alt margin-1 no-margin-bottom no-margin-rl text-large text-gray-dark">Netværksmødet afholdes om:</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 sm-margin-4 sm-no-margin-bottom sm-no-margin-rl" data-mh="mh-col-countdown">
                                    <div class="clock" data-until-date="1516167000">
                                        <div class="clock-item">
                                            <div class="display-table height-100 width-100">
                                                <div class="display-table-cell vertical-align-middle">
                                                    <span class="display-block xs-text-extra-large title-medium">
                                                        {{ days }}
                                                    </span>
                                                    <span class="display-block text-small">dage</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clock-item">
                                            <div class="display-table height-100 width-100">
                                                <div class="display-table-cell vertical-align-middle">
                                                    <span class="display-block xs-text-extra-large title-medium">
                                                        {{ hours }}
                                                    </span>
                                                    <span class="display-block text-small">timer</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clock-item">
                                            <div class="display-table height-100 width-100">
                                                <div class="display-table-cell vertical-align-middle">
                                                    <span class="display-block xs-text-extra-large title-medium">
                                                        {{ minutes }}
                                                    </span>
                                                    <span class="display-block text-small">min.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clock-item">
                                            <div class="display-table height-100 width-100">
                                                <div class="display-table-cell vertical-align-middle">
                                                    <span class="display-block xs-text-extra-large title-medium">
                                                        {{ seconds }}
                                                    </span>
                                                    <span class="display-block text-small">sek.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            deadline: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                now: Math.trunc((new Date()).getTime() / 1000),
                date: null,
                diff: 0,
                interval: null
            }
        },
        mounted () {
            this.date = Math.trunc(Date.parse(this.deadline.replace(/-/g, '/')) / 1000)
            this.interval = setInterval(() => {
                this.now = Math.trunc((new Date()).getTime() / 1000)
            }, 1000)
        },
        beforeDestroy () {
            clearInterval(this.interval)
        },
        computed: {
            seconds () {
                return Math.trunc(this.diff) % 60
            },
            minutes () {
                return Math.trunc(this.diff / 60) % 60
            },
            hours () {
                return Math.trunc(this.diff / 60 / 60) % 24
            },
            days () {
                return Math.trunc(this.diff / 60 / 60 / 24)
            }
        },
        watch: {
            now (value) {
                this.diff = this.date - this.now
                if (this.diff <= 0 || this.stop) {
                    this.diff = 0
                    // Remove interval
                    clearInterval(this.interval)
                }
            }
        }
    }
</script>
<style scoped>
    .col-md-6.countdown-text{
        height: 88px;
    }
</style>



// WEBPACK FOOTER //
// countdown.vue?0c63b596